import axios from "axios"
import config from "../config/config";
import Utils from "@/utils/utils.js"

const utils = new Utils(); //实例化工具类
let that = this;
import {Message} from 'element-ui';
import store from "@/store";

// 创建 axios 实例
const service = axios.create({
    baseURL: config.BASE_URL,
    timeout: 10000 // 10秒超时
});

// 请求拦截器，统一加 token
service.interceptors.request.use(
    (config) => {
        const token = utils.getCookie("token");
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);
service.interceptors.response.use(
    response => response,
    error => {
        // 接口认证失败的信息
        if (error.response && error.response.status === 401) {

            // 使用 window.location 跳转，因为这里没有 router 实例
            // window.location.href = "/login"
        }
        return Promise.reject(error)
    }
)

export const request = (options) => {
    return new Promise((resolve, reject) => {
        let data = options.data || "";
        let method = options.method ? options.method.toLowerCase() : "get";
        let url = options.url;

        let axiosConfig = {};
        if (method === "get") {
            axiosConfig = {params: data};
        } else if (method === "delete") {
            axiosConfig = {data};
        } else {
            axiosConfig = data;
        }

        service[method](url, axiosConfig)
            .then(handleResponse)
            .catch(handleError);

        // 处理响应
        function handleResponse(res) {
            //如果因为auth拒绝了请求则state退出
            if (res.data.code == 10001) {
                store.commit("SET_LOGIN", false);
                utils.clearCookie("token");
                store.commit("SET_TOKEN", false);
                store.commit("SET_USERINFO", {});
                // 使用 window.location 跳转，因为这里没有 router 实例
                window.location.href = "#/"
                console.log("登录过期，请重新登录")
                reject(res);
            } else {
                resolve(res);
            }
        }

        // 处理错误
        function handleError(err) {
            // Message.error("error:40001,请求失败!");
            reject(err);
        }
    })
}
